<div class="conditions-container">
  <div class="conditions-list">
    <p-table
      [value]="conditions"
      [paginator]="true"
      [rows]="10"
      [rowsPerPageOptions]="[5, 10, 20]"
      [globalFilterFields]="['value.methName', 'value.kommentar']"
      [scrollable]="true"
      scrollHeight="400px"
    >
      <ng-template pTemplate="header">
        <tr>
          <th id="id-column">ID</th>
          <th id="orden-column">Orden</th>
          <th id="descripcion-column">Descripción</th>
          <th id="actua-sobre-column">Actúa Sobre</th>
          <th id="id-detalle-column">Id</th>
          <th id="nombre-column">Nombre</th>
          <th id="perfil-column">Perfil</th>
          <th id="oper-column">Oper.</th>
          <th id="nombre-operador-column">Nombre operador</th>
          <th id="valor-column">Valor</th>
          <th id="neg-column">Neg</th>
          <th id="excl-column">Excl</th>
          <th id="visible-column">Visible</th>
          <th id="isolate-column">Aisl</th>
          <th id="tipo-res-column">Tipo Res.</th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-conditionControl
        let-rowIndex="rowIndex"
      >
        <tr>
          <td>{{ conditionControl.value.condRule }}</td>
          <td>{{ conditionControl.value.posC }}</td>
          <td>{{ conditionControl.value.kommentar }}</td>
          <td>{{ conditionControl.value.condId }}</td>
          <td>{{ conditionControl.value.saveValue | inherited }}</td>
          <td>{{ conditionControl.value.methName }}</td>
          <td>{{ conditionControl.value.grupNr }}</td>
          <td>{{ conditionControl.value.rOperator }}</td>
          <td>{{ conditionControl.value.labelOperator }}</td>
          <td>{{ conditionControl.value.entryValue }}</td>
          <td>{{ conditionControl.value.negCond | SNCheck }}</td>
          <td>{{ conditionControl.value.exitCond }}</td>
          <td>{{ conditionControl.value.visible }}</td>
          <td>{{ conditionControl.value.isolate }}</td>
          <td>{{ conditionControl.value.tipoRes }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="15" style="text-align: center">
            No hay condiciones definidas
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
